<div class="frb" *ngIf="isVisible" role="status">
  <div class="frb__text">
    <span class="frb__icon"><i class="pi" [ngClass]="isGroup ? 'pi-gift' : 'pi-megaphone'"></i></span>
    <span class="frb__label">{{ entry.banner.label || 'Feature' }}</span>
    <span class="frb__message" [title]="entry.banner.text">{{ entry.banner.text }}</span>
  </div>
  <div class="frb__actions">
    <button type="button" class="_primary-btn frb__btn" (click)="viewNow()">
      {{ isGroup ? 'View Features' : 'View Now' }}
      <i class="pi pi-arrow-right"></i>
    </button>
    <button type="button" class="_outline-btn frb__btn" (click)="ignore()">Ignore</button>
    <button type="button" class="frb__close" aria-label="Hide" title="Hide For Now" (click)="dismiss()">
      <i class="pi pi-times"></i>
    </button>
  </div>
</div>
